import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setSimCardType, setSelectedBanNumber } from '../../TransferOrganizationAccountSlice';
import SelectOptionButton from '../../../../Shared/SelectOptionButton/SelectOptionButton';

const SelectBanNumberComponent = (props) => {
  const [banListForSelect, setBanListForSelect] = useState([]);

  useEffect(() => {
    if (props.data.banListForSelect?.length > 0) {
      getBanListForSelect();
    } else setBanListForSelect([]);
  }, [props.data.banListForSelect]);

  function getBanListForSelect() {
    if (props.data.banListForSelect?.length > 0) {
      props.data.banListForSelect.map((ban, index) => {
        const selected = props.data.selectedBanNumber == ban.banNumber ? true : false;
        const item = {
          id: index,
          label: `מספר לקוח | ${ban.banNumber} `,
          rightContent: ban.orgName,
          value: ban.banNumber,
          selected: selected,
        };
        setBanListForSelect((oldArray) => [...oldArray, item]);
      });
    }
  }

  return (
    <div className='transfer-line-sub-step borderline'>
      {banListForSelect.length > 0 && (
        <SelectOptionButton title={'מה מספר הלקוח אליו ישוייך הקו?'} buttonsData={banListForSelect} onClick={props.setSelectedBanNumber} />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.TransferOrganizationAccount,
  };
};

const mapDispatchToProps = {
  setSimCardType,
  setSelectedBanNumber,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectBanNumberComponent);
